import { DROPDOWN_DISPLAY_NAME } from "./core";
import createTestId from "../../../fabrics/createTestId";

export const createTestIdForDropdownElement = createTestId(
    DROPDOWN_DISPLAY_NAME,
);
